var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-footer"},[_c('span',[_vm._v(_vm._s(_vm.isAgent ? this.$t('System.Agency') : this.$t('System.Dealer')))])])}
var staticRenderFns = []

export { render, staticRenderFns }